import React, { Component } from 'react'
import update from 'immutability-helper'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { Draggable } from 'react-beautiful-dnd'
// import TextareaAutosize from 'react-textarea-autosize'
import TextareaAutosize from 'react-autosize-textarea'

import Switch from '../../../common/switch'

class ListItem extends Component {
  constructor(props) {
    super(props)

    this.state = {
      item: undefined,
      required: false,
      showDropdown: false
    }
  }

  componentWillMount() {
    const { item, required } = this.props

    this.setState({item, required})
  }

  componentWillReceiveProps(nextProps) {
    const { item, required } = nextProps

    if (this.props.item !== item) this.setState({item})
    if (this.props.required !== required) this.setState({required})
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { item, required } = nextProps

    if (item !== this.props.item) return true
    if (required !== this.props.required) return true
    if (nextState !== this.state) return true
    return false
  }

  renderDropdown(item) {
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showDropdown: !showDropdown})} />

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              <li onClick={() => this.setState({showDropdown: false}, () => this.props.deleteRiderItem(item.id))}>Remove requirement</li>
            </ul>
          : null
        }
      </div>
    )
  }

  renderEmptyListItem(item) {
    return (
      <div className="list-item list-item--empty">
        <div className="list-item-handle" />

        <div className="riek-escape" onClick={() => {
          if (!item.content) this.props.removeRiderItem(item)
        }} />

        <TextareaAutosize
          autoFocus={true}
          value={item.content || ''}
          className="textarea-autosize"
          onChange={(e) => {
            this.setState({
              item: update(item, {
                content: {$set: e.target.value}
              })
            })
          }}
          onBlur={() => {
            if (item.content) this.props.createRiderItem({...item, type: 'requirement', content: item.content})}
          } />
      </div>
    )
  }

  renderListItem(item) {
    const { view, required } = this.props

    const textareaClassName = classnames({
      'textarea-autosize': true,
      'placeholder': !item.content
    })

    return (
      <Draggable draggableId={item.id} isDragDisabled={!view.editable} type="requirement">
        {(provided, snapshot) => (
          <div className="list-item">
            {
              view.editable
              ? this.renderDropdown(item)
              : null
            }

            <div className="list-item--draggable"
              ref={provided.innerRef}
              style={provided.draggableStyle} >
              {
                view.editable
                ? <div className="list-item-handle" {...provided.dragHandleProps} />
                : null
              }

              <div className="list-item-content">
                {
                  view.editable
                  ? <TextareaAutosize
                      value={item.content !== null ? item.content : 'Please click to add requirement'}
                      className={textareaClassName}
                      onClick={() => {
                        if (item.content === null) {
                          this.setState({
                            item: update(item, {
                              content: {$set: ''}
                            })
                          })
                        }
                      }}
                      onChange={(e) => {
                        this.setState({
                          item: update(item, {
                            content: {$set: e.target.value}
                          })
                        })
                      }}
                      onBlur={() => {
                        if (item.content) {
                          this.props.editRiderItem({id: item.id, content: item.content})
                        } else {
                          this.setState({
                            item: update(item, {
                              content: {$set: null}
                            })
                          })
                        }
                      }} />
                  : <div className={textareaClassName}>{item.content}</div>
                }

                {
                  view.editable
                  ? <Switch
                      required={required}
                      toggleSwitch={(required) => this.setState({required}, () => this.props.editRiderItem({id: item.id, required}))} />
                  : item.required
                    ? <div>Required</div>
                    : <div>Band brings</div>
                }
              </div>
            </div>

            {provided.placeholder}
          </div>
        )}
      </Draggable>
    )
  }

  render() {
    const { item } = this.state

    return item.id !== undefined
    ? this.renderListItem(item)
    : this.renderEmptyListItem(item)
  }
}

ListItem.propTypes = {
  view: PropTypes.object,
  item: PropTypes.object,
  required: PropTypes.bool,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func
}

ListItem.defaultProps = {
  view: {},
  item: {},
  required: false,
  removeRiderItem: function() {},
  createRiderItem: function() {},
  editRiderItem: function() {},
  deleteRiderItem: function() {}
}

export default ListItem



// WEBPACK FOOTER //
// ./src/components/rider/rider-requirements/requirement-list/list-item.js